import { Component, Input, Output, EventEmitter } from '@angular/core';

import { FilterOption } from '@portals/api';

@Component({
	selector: 'portals-moment-filter-autocomplete',
	templateUrl: './moment-filter-autocomplete.component.html',
	styleUrls: ['./moment-filter-autocomplete.component.scss'],
})
export class MomentFilterAutocompleteComponent {
	@Input() selectedTypes: string[] = [];
	@Input() selectedNames: (FilterOption | string)[] = [];
	@Input() entityName: string = '';
	@Output() onValueChange = new EventEmitter<any>();
	filterParam: object = {};

	constructor() {}

	onChangeTypeFieldValue(event: any) {
		const { value } = event || {};
		this.selectedTypes = value;
		this.filterParam = {
			type: {
				$in: this.selectedTypes,
			},
		};
	}

	onChangeNameFieldValue(event: any) {
		const { value } = event || {};
		this.selectedNames = value;
		this.onValueChange.emit({
			value: this.selectedNames,
			subValue: this.selectedTypes,
			isMultiSelect: true,
		});
	}
}
